import SearchableSelect from './SearchableSelect';
import { useMemo } from 'react';

export default function ClientCombobox({
  clients = [],
  value = '',
  onChange,
  placeholder = 'All locations',
  allowEmpty = true,
  disabled = false,
  className = '',
}) {
  const options = useMemo(
    () => [
      ...(allowEmpty ? [{ value: '', label: placeholder }] : []),
      ...clients.map((c) => ({
        value: c._id,
        label: c.serpstatDomain ? `${c.clientName} (${c.serpstatDomain})` : c.clientName,
      })),
    ],
    [clients, placeholder, allowEmpty],
  );

  return (
    <SearchableSelect
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={options}
      placeholder={placeholder}
      searchPlaceholder="Search locations…"
      panelMinWidth={320}
      disabled={disabled}
      className={className}
      placeholderValues={['']}
    />
  );
}
